import { api } from '../../../shared/services/api';

export interface PetsAndVehiclesCounts {
  items: Array<{
    pets: Array<any>;
    vehicles: Array<any>;
    userId: string;
    userName: string;
  }>;
}

export const dashboardService = {
  getActiveUserGraph: async () => {
    const response = await api.get('/statistics/active-users');
    return response.data;
  },
  getAccessLogGraph: async () => {
    const response = await api.get('/statistics/access-logs');
    return response.data;
  },

  getAccessLogs: async () => {
    const response = await api.get('/statistics/access-logs/list');
    return response.data;
  },

  getDashboardCounts: async () => {
    const response = await api.get('/statistics/dashboard-counts');
    return response.data;
  },

  getDashboardSummaryToday: async () => {
    const response = await api.get('/statistics/today');
    return response.data;
  },

  getPetsAndVehiclesCounts: async (): Promise<PetsAndVehiclesCounts> => {
    const response = await api.get<PetsAndVehiclesCounts>('/statistics/pet-vehicle-count');
    return response.data;
  }
};